import type { IconProps } from './../../models/icon';

export function SingleDocumentIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        fillRule="evenodd"
        d="M20.9266 22.6407C21.248 22.3193 21.4287 21.8832 21.4287 21.4285V9.42854H12.8572V0.857117H4.28582C3.83116 0.857117 3.39513 1.03773 3.07363 1.35922C2.75215 1.68071 2.57153 2.11674 2.57153 2.5714V21.4285C2.57153 21.8832 2.75215 22.3193 3.07363 22.6407C3.39513 22.9621 3.83116 23.1428 4.28582 23.1428H19.7144C20.169 23.1428 20.6051 22.9621 20.9266 22.6407Z"
        clipRule="evenodd"
      />
      <path fill="transparent" d="M12.8574 0.857117V9.42854H21.4289" />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M21.4287 21.4285C21.4287 21.8832 21.248 22.3193 20.9266 22.6407C20.6051 22.9621 20.169 23.1428 19.7144 23.1428H4.28582C3.83116 23.1428 3.39513 22.9621 3.07363 22.6407C2.75215 22.3193 2.57153 21.8832 2.57153 21.4285V2.5714C2.57153 2.11674 2.75215 1.68071 3.07363 1.35922C3.39513 1.03773 3.83116 0.857117 4.28582 0.857117H12.8572L21.4287 9.42855V21.4285Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12.8574 0.857117V9.42854H21.4288"
      />
    </svg>
  );
}
